import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ConstructionInfo from '../../components/ConstructionInfo/ConstructionInfo';
import Hero from '../../components/Hero';
import isEmpty from '../../utils/isEmpty';
import NewsListModule from '../../components/NewsListModule';
import StreamField from '../../components/StreamField';
import i18n from '../../i18n';
import styles from './AreaPage.module.scss';

const AreaPage = ({ breadcrumbs, hero, contentBlocks, title, news, meta }) => {
    return (
        <div className={styles['AreaPage']}>
            {!isEmpty(hero) && <Hero {...hero} />}
            <Breadcrumbs {...breadcrumbs} modifier={"ArticlePage"}/>

            <div className={styles['AreaPage__Container']}>
                <h1 className={styles['AreaPage__Title']}>{title}</h1>

                <ConstructionInfo {...meta} />

                {!isEmpty(contentBlocks) && (
                    <StreamField items={contentBlocks} />
                )}
            </div>
            {news && news.items && news.items.length > 0 && (
                <NewsListModule
                    heading={i18n.t('newsDetailPage.moreHeading')}
                    {...news}
                />
            )}
        </div>
    );
};

AreaPage.propTypes = {
    breadcrumbs: PropTypes.array,
    hero: PropTypes.object,
    contentBlocks: PropTypes.array,
    title: PropTypes.string,
    preamble: PropTypes.string,
    news: PropTypes.object,
};

AreaPage.defaultProps = { hero: {} };

export default basePageWrap(AreaPage);
